import { ReactNode } from "react";
import Button, { ButtonProps } from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { RenderWhen } from "../components";

interface LoadingButtonProps extends ButtonProps {
  isLoading: boolean;
  loadingText?: string;
  children: ReactNode;
  size?: "sm";
}

const LoadingButton = ({
  isLoading,
  loadingText = "",
  children,
  size,
  ...otherProps
}: LoadingButtonProps) => (
  <Button disabled={isLoading} {...otherProps}>
    <RenderWhen condition={isLoading} fallback={children}>
      <>
        <Spinner animation="border" size={size} />
        {loadingText}
      </>
    </RenderWhen>
  </Button>
);

export default LoadingButton;
